<template>
  <v-container class="text-center mt-10">
    <!-- Stato: caricamento -->
    <div v-if="loading" class="my-10">
      <v-progress-circular
        indeterminate
        color="primary"
        size="80"
      ></v-progress-circular>
      <h3 class="mt-6">Conferma del pagamento in corso...</h3>
    </div>

    <!-- Stato: errore -->
    <div v-else-if="error" class="my-10">
      <v-icon color="red" size="80">mdi-alert-circle</v-icon>
      <h2 class="mt-4">Errore nella conferma del pagamento</h2>
      <p class="grey--text">{{ error }}</p>
      <v-btn color="primary" class="mt-4" to="/abbonamento">Torna alla pagina abbonamento</v-btn>
    </div>

    <!-- Stato: successo -->
    <div v-else class="my-10">
      <v-icon color="green" size="80">mdi-check-circle</v-icon>
      <h2 class="mt-4">Pagamento completato con successo!</h2>
      <p class="mt-2">Grazie per aver rinnovato l'abbonamento 🎉</p>

      <v-card class="mx-auto mt-6 pa-4" max-width="400" outlined>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Piano: {{ info.plan }}
            </v-list-item-title>
            <v-list-item-subtitle>Importo: {{ info.amount }} €</v-list-item-subtitle>
            <v-list-item-subtitle>
              Scadenza: {{ formatDate(info.expiryDate) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-btn color="primary" class="mt-6" to="/dashboard">
        Torna alla Dashboard
      </v-btn>

      <p class="grey--text text--darken-1 mt-3">
        Verrai reindirizzato automaticamente tra {{ redirectCountdown }} secondi...
      </p>
    </div>
  </v-container>
</template>

<script>
import axios from '@/api/axios';

export default {
  name: "AbbonamentoSuccess",
  data() {
    return {
      loading: true,
      error: null,
      info: null,
      redirectCountdown: 8, // secondi prima del redirect automatico
    };
  },
  methods: {
    async confermaPagamento(sessionId) {
      try {
        const { data } = await axios.get(`/payments/confirm?session_id=${sessionId}`);
        this.info = data;
      } catch (err) {
        console.error(err);
        this.error = "Impossibile confermare il pagamento. Riprova o contatta il supporto.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    startRedirectTimer() {
      const timer = setInterval(() => {
        if (this.redirectCountdown > 0) this.redirectCountdown--;
        else {
          clearInterval(timer);
          this.$router.push("/dashboard");
        }
      }, 1000);
    },
  },
  async mounted() {
    // 🔹 Ripristina autenticazione se la pagina è ricaricata da Stripe
    this.$store.dispatch('auth/autoLogin');

    const sessionId = this.$route.query.session_id;
    if (!sessionId) {
      this.error = "Sessione non valida o mancante.";
      this.loading = false;
      return;
    }

    await this.confermaPagamento(sessionId);

    // 🔹 Se confermato con successo, parte il timer per redirect automatico
    if (!this.error) {
      this.startRedirectTimer();
    }
  },
};
</script>

<style scoped>
.v-icon {
  font-size: 80px;
}
</style>
